import computeClassName from "../../../../../../utils/computeClassName";

export default function CCLoaderCircleLarge({className}) {
  const computedClassName = computeClassName(className, '');
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path fillRule="evenodd" clipRule="evenodd" d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#D7E1FE"/>
      <mask id="maskCCLoaderCircleLarge" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20">
        <path fillRule="evenodd" clipRule="evenodd" d="M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="white"/>
      </mask>
      <g mask="url(#maskCCLoaderCircleLarge)">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 5C15.866 5 19 8.13401 19 12H22C22 6.47714 17.5229 2 12 2V5Z" fill="#0076D5"/>
      </g>
    </svg>
  );
}


